import React from "react";
import {myGlobals, myUtilities} from "../Utils";
import InProgress from "../Images/InProgressBig.png";


export default class PaymentInprogressNotify extends React.Component {

  

  constructor(props) {
    super(props);
    this.state = {
      name: 'React',
      fields: {
                emailAddress: '',
      },
      errors: {
               emailAddress: '',
      },
      responseOfEmailIds: '',
      loaded:false,
     
      visibilityState:true

    };
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
validate = (name, value) => {
    switch (name) {
      case 'emailAddress':
        if (!value) {
          return  myUtilities.accountSpecificLanguage(
            "payment.inProgress.receipt.notification.emailrequired",
            "Email is Required ");
        } else {
          let message = '';
          value =  value.replace(/(?:\r\n|\r|\n|\t|\s)/g, '');
          if(value.length>512){
            return myUtilities.accountSpecificLanguage(
              "payment.inProgress.receipt.notification.exceededlimit", 
              "Email text exceeded"
              );
            }
          const answer_array = value.split(',');
          if(answer_array.length>=11){
          return  myUtilities.accountSpecificLanguage(
          "payment.inProgress.receipt.notification.emaillimit",
          "upto 10 emails allowed"
             );
          }
          answer_array.forEach((key) => {
          if (!key.match(
            /^[a-z0-9]([a-z0-9_\-\.]*)@([a-z0-9_\-\.]*)(\.[a-z]{2,4}(\.[a-z]{2}){0,2})$/i
          ) ) {
          message = message+' '+key;
          } else {
          return '';
          }
          });
          if(!message){
            return '';
          }
          return myUtilities.accountSpecificLanguage(
            "payment.inProgress.receipt.notification.validemail",
            "Enter valid emailId : " 
            )+message;
          }
      default: {
        return '';
      }
    }
  };

  handleUserInput = e => {
    this.setState({ responseOfEmailIds: '' });
    const getCircularReplacer = () => {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    };
    const { name, value, children, multiple } = e.target;
    if (multiple && children.length > 0) {
      const selectedChildren = Array.from(children)
        .filter(child => child.selected)
        .map(child => child.value);
      JSON.stringify(Array.from(children), getCircularReplacer());
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: this.validate(name, selectedChildren)
        },
        fields: {
          ...this.state.fields,
          [name]: selectedChildren
        }
      });
      return;
    }

    this.setState({
      errors: {
        ...this.state.errors,
        [name]: this.validate(name, value)
      },
      fields: {
        ...this.state.fields,
        [name]: value
      }
    });
  };


handleSubmit = async e => {
    const { fields, error } = this.state;
    e.preventDefault();
    let validationErrors = {};
    Object.keys(fields).forEach(name => {
      const error = this.validate(name, fields[name]);
      if (error && error.length > 0) {
        validationErrors[name] = error;
      }
    });
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ errors: validationErrors });
      return;
    }
    if ( fields.emailAddress ) {
    let emailIds = fields.emailAddress;
    if(emailIds){
      emailIds = emailIds.replace(/(?:\r\n|\r|\n|\t|\s)/g, '');
    }
    
    const searchParams = new URLSearchParams();
    searchParams.append('token',myGlobals.token);
    if (myGlobals.jsonString.ccSplitIds !== undefined && myGlobals.jsonString.ccSplitIds !== null){
      searchParams.append('splitIds',myGlobals.jsonString.ccSplitIds);
    }else{
      searchParams.append('splitIds',myGlobals.jsonString.splitIds);
    }
    searchParams.append('emailId',emailIds);
    
    let link = 'updateGuestPayMailIds';
    link = myGlobals.initialHost+myGlobals.appender+link;
   // let link = 'https://api.npoint.io/16c8fc20c726f800ee5e';
    await fetch(link, {
      method: "POST",
      body: searchParams
    }).then(
      function(response){
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' +
            response.status);
            return ;
        }
          return response.json();
      }
      ).then((data) => {
      if(data !== undefined && data.rows !== undefined && data.rows === true){
     // fields.emailAddress = '';
      this.setState({ loaded : true });
      this.setState({ responseOfEmailIds: 'success' });
     // this.setState({ fields: ''});
     this.setState({ visibilityState: false});
      }else{
        this.setState({ responseOfEmailIds: 'failed' });
      }  
      }).catch(
      function(err)
      {
        console.log('Fetch Error :-S',err);  
      });
    }
  };

  componentDidMount = async() => {
  
       let link = 'getNotificationEnabled';
       link = myGlobals.initialHost+myGlobals.appender+link;
      // let link = 'https://api.npoint.io/16c8fc20c726f800ee5e';
        const searchParams = new URLSearchParams();
        searchParams.append('token',myGlobals.token);
       await  fetch(link, {
        method: "POST",
        body: searchParams
        }).then(
          function(response){
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }
        ).then((data) => {
          if(data !== undefined && data.rows !== undefined && data.rows === true){
          this.setState({ loaded : true });
          }  
      }).catch(
          function(err)
          {
            console.log('Fetch Error :-S',err);  
          });
          

  }
  render() {
    const { fields, errors,responseOfEmailIds, loaded,visibilityState } = this.state;
    return (      
      <div className="centered-container">
      <React.Fragment>
        <img className="tick-image" src={InProgress}/>
        <br /> <br />
        <div className="payment-complete-div">
        <lable style={{display: 'inline-block', fontSize: 16}}>
        {
        (myGlobals.jsonString.paymentType !== undefined   && myGlobals.jsonString.paymentType === 'ACH') ? myUtilities.accountSpecificLanguage("payment.PaymentisSubmittedforprocessing", "Payment is Submitted for processing"):
        myUtilities.accountSpecificLanguage("payment.inProgress", "Payment in progress")}
          !</lable>
        <br /><br/>
        <div> 
        {loaded && <div>
        <lable style={{display: 'inline-block', fontSize: 16}}>{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.warning","The payment is currently in progress.")} </lable><br/>
        <lable style={{display: 'inline-block', fontSize: 16, fontWeight: 'bold'}}>{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.referenceid","Reference Transaction id : ") + myGlobals.jsonString.transactionID}</lable><br/><br/>
       <lable style={{display: 'inline', fontSize: 16}}>{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.emaillable.warning",
       "Enter your email id below, if you wish to receive a confirmation receipt once the transaction is complete") }</lable><br/><br/>
       <form onSubmit={this.handleSubmit}>
       <div>
       <lable style={{ fontSize: 16}}>{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.emaillable","Email Address : ") }</lable> &nbsp; &nbsp;
        <textarea name="emailAddress" disabled={visibilityState? false : true} style={{ fontSize: 16}} value={fields.emailAddress} margin = 'normal'
        placeholder = {myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.placeholder.email","Enter email ids...")} rows="2"  cols="36"  onChange={event => this.handleUserInput(event)}></textarea></div> <br/>
        &ensp;  &ensp;  &ensp;  &ensp;  &ensp;  &ensp;  &ensp;  &ensp;  &ensp;  &ensp; <lable   style={{ fontSize: 10 , fontStyle: 'italic',   textalign: 'right'}} > {myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.info.message","commas can be used to separate multiple email addresses")}</lable>
       <div className="text-danger">
       <span style={{ fontSize: 12}}>{errors.emailAddress}</span></div>  
       <div className="text-center">        
       <button  class="btn btn-primary" style={{visibility: visibilityState ? "showing" : "hidden"}} disabled={!fields.emailAddress} >{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.save.button","Save Email Ids")}</button>
       </div>  </form></div>
        }{!loaded && myUtilities.accountSpecificLanguage("payment.inProgress.receipt.warning","The payment is currently in progress. Please contact administrator.")} 
        {loaded && responseOfEmailIds === 'success'&& <lable style={{ color: 'green',fontSize: 16 }}> {myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.success","Emails saved successfully")} </lable>} 
        {loaded && responseOfEmailIds === 'failed' && <lable style={{ color: 'red',fontSize: 16 }}>{myUtilities.accountSpecificLanguage("payment.inProgress.receipt.notification.failed","Emails failed to save")} </lable>}               
       </div> </div>
      </React.Fragment>
    </div>
   )
  }
}